import PermanenceReportState from './PermanenceReportContext/PermanenceReportState'
import EntryAndDepartureReportState from './EntryAndDepartureReportContext/EntryAndDepartureReportState'

const ReportsContext = ({children}) => {
    return (
        <EntryAndDepartureReportState>
            <PermanenceReportState>
                {children}
            </PermanenceReportState>
        </EntryAndDepartureReportState>
    )
}

export default ReportsContext